import moment from "jalali-moment";

export const EVENT_TYPE_META = {
  دادگاه: { icon: "court", label: "دادگاه" },
  قرارملاقات: { icon: "time", label: "قرار ملاقات" },
  جلسه: { icon: "calculate", label: "جلسه" },
  "جلسه رسیدگی": { icon: "calculate", label: "جلسه" },
  "تنظیم لایحه": { icon: "calculate", label: "تنظیم لایحه" },
  "تنظیم لایحه یا هرمتنی": { icon: "calculate", label: "تنظیم لایحه" },
};

export function getEventTypeMeta(type) {
  return EVENT_TYPE_META[type] || { icon: "bell", label: "رویداد" };
}

// ساعتِ رویداد را به وقت ایران (+۰۳:۳۰) و به‌صورت [HH, mm] برمی‌گرداند
export function getEventTime(time) {
  return moment(time).utcOffset("+0330").format("HH:mm").split(":");
}

const faPad2 = (n) =>
  new Intl.NumberFormat("fa-IR", { minimumIntegerDigits: 2 }).format(Number(n));

export function formatEventTimeFa(time) {
  const [h, m] = getEventTime(time);
  return `${faPad2(h)}:${faPad2(m)}`;
}

// تاریخ کامل شمسی رویداد به همراه نام روز هفته، برای استفاده در متن اشتراک‌گذاری
export function formatEventDateFa(time) {
  return moment(time)
    .utcOffset("+0330")
    .locale("fa")
    .format("dddd jD jMMMM jYYYY");
}

/**
 * متن نهایی برای اشتراک‌گذاری یک رویداد را از روی props واقعی EventDateItem می‌سازد.
 */
export function buildEventShareText(props) {
  const { label: typeLabel } = getEventTypeMeta(props.type);
  const lines = [];

  lines.push(props.title ? `${typeLabel} : ${props.title}` : typeLabel);
  lines.push("");
  lines.push(`تاریخ : ${formatEventDateFa(props.time)}`);
  lines.push(`ساعت : ${formatEventTimeFa(props.time)}`);

  if (props.case) {
    lines.push(`پرونده : ${props.case}`);
  }

  if (props.body) {
    lines.push("");
    lines.push("توضیحات :");
    lines.push(props.body);
  }

  lines.push("");
  lines.push(`اطلاع‌رسانی پیامکی : ${props.send_sms ? "فعال" : "غیرفعال"}`);
  if (typeof props.isPublic !== "undefined") {
    lines.push(`نمایش برای موکل : ${props.isPublic ? "فعال" : "غیرفعال"}`);
  }

  lines.push("");
  lines.push("اپلیکیشن مدیریت دفتر وکیل و هوش مصنوعی حقوقی وکیلسان");
  lines.push("https://vakilsun.com");

  return lines.join("\n");
}
